import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import zh from "./i18n/lang/zh";
import en from "./i18n/lang/en";
import "normalize.css";
import VueI18n from "vue-i18n";
import Print from "@/components/print";
var infiniteScroll = require("vue-infinite-scroll");
Vue.use(infiniteScroll);
Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(VueI18n);
Vue.use(Print);
const messages = {
  en: en,
  zh: zh,
};
const i18n = new VueI18n({
  locale: "zh", // set default locale
  messages, // set locale messages
});
Vue.prototype.$apiUrl = "https://jf.infor.ltd";
// Vue.prototype.$apiUrl = "http://127.0.0.1:7001";
console.log(999);
new Vue({
  router,
  store,
  i18n,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
